import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class vignettePreview_template extends vnTemplate {

    protected getTemplateHtml(): string {

        return /*html*/ `
            <div id="previewContainer" style="width: 100%;">
                <iframe id="preview" width="100%" class="w-iframe" style="height: 300px;" data-bind="event: { load: iframeOnLoad }, attr: { srcdoc: previewHtml }, visible: html() != ''" sandbox="allow-same-origin"></iframe>
            </div>
        `;
    }

    protected initPartial(): void {

        const self = this;
    }

    protected getTemplateName(): string {

        return "vignettePreview_template";
    }

    protected buildViewModel(): any {

        const self = this;

        return {
            html: ko.observable(""),
            css: ko.observable(""),
            showKeys: ko.observable(false),
            indexedCssValues: ko.observable({}),
            indexedHtmlValues: ko.observable({}),
            previewHtml: ko.pureComputed(this.updatePreview.bind(this)),
            isFixedHeight: ko.observable(false),
            defaultHeight: ko.observable("300px"),
            iframeOnLoad: this.iframeOnLoad.bind(this),
        }
    }

    protected iframeOnLoad(data, event){
        const iframe = event.target;
        this.updateHeight(iframe);
    }

    protected updateHeight(target): void {
        if(this.getTemplateViewModel().isFixedHeight()) {
            target.style.height = this.getTemplateViewModel().defaultHeight();
            target.style.overflow = 'auto';
        } else {
            const contentDocument = target.contentDocument || target.contentWindow.document;
            const contentHeight = contentDocument.body.scrollHeight;
            target.style.height = contentHeight + 'px';
        }
    }

    public setIsFixedHeight(value: boolean): void {
        this.getTemplateViewModel().isFixedHeight(value);
    }

    public setDefaultHeight(value: string): void {
        this.getTemplateViewModel().defaultHeight(value);
    }

    public setVignette(vignette) {
        let html = '';
        let css = '';

        if(vignette) {
            html = vignette.html;
            css = vignette.css;
        }

        this.getTemplateViewModel().html(html);
        this.getTemplateViewModel().css(css);
    }

    public setHtml(value): void {
        this.getTemplateViewModel().html(value);
    }

    public setCss(value): void {
        this.getTemplateViewModel().css(value);
    }

    public setShowKeys(value): void {
        this.getTemplateViewModel().showKeys(value);
    }

    public getRenderedHtmlTemplate(): string {
        let html = this.getTemplateViewModel().html();
        const replacement = this.getTemplateViewModel().indexedHtmlValues();
        return html.replace(/\[\[[\w-]+\]\]/g, function(match) {
            const key = match.slice(2, -2).toLowerCase();
            let replacedValue: string;
            if(this.getTemplateViewModel().showKeys()) {
                replacedValue = replacement[key] ? replacement[key] : match;
            } else {
                replacedValue = replacement[key] ? replacement[key] : '';
            }
            return replacedValue;
        }.bind(this));
    }

    public getRenderedCssTemplate(): string {
        let css = this.getTemplateViewModel().css();
        const replacement = this.getTemplateViewModel().indexedCssValues();

        return css.replace(/\[\[[\w-]+\]\]/g, function(match) {
            const key = match.slice(2, -2).toLowerCase();
            let replacedValue: string;
            if(this.getTemplateViewModel().showKeys()) {
                replacedValue = replacement[key] ? replacement[key] : match;
            } else {
                replacedValue = replacement[key] ? replacement[key] : '';
            }
            return replacedValue;
        }.bind(this));
    }

    protected updatePreview(): string {


        return /*html*/ `
            <html>
                <head>
                    <style>
                        body {
                            margin: 0;
                            padding: 0;
                            overflow: hidden;
                        }
                        ${this.getRenderedCssTemplate()}
                    </style>
                </head>
                <body>
                    ${this.getRenderedHtmlTemplate()}
                </body>
            </html>`;
    }

    public getCss(): string {
        return this.getTemplateViewModel().css();
    }

    public setIndexedValues(tag, specValues: Array<any> = [], specDefaults: Array<any> = []) {
        let indexedHtmlValues = {};
        let indexedCssValues = {};

        if(tag) {
            let tagTypeField: any;
            let specHtmlValue: string;
            let specCSSValue: string;
            let reference: string;
            if(tag.type) {
                const processSpec = (spec: any) => {
                    if (spec.isDefault) {
                        // default specs should be ignored.
                        return;
                    }
                    specHtmlValue = '';
                    specCSSValue = '';
                    tagTypeField = tag.type.fields.find((field: any) => field.id === spec.fieldId);
                    if(tagTypeField && tagTypeField.reference){
                        if (spec.dataType === 'tag') {
                            specCSSValue = specHtmlValue = spec.value && spec.value[0] ? spec.value[0].name : null;
                        } else if (spec.dataType === 'tags') {
                            let values = [];
                            if (Array.isArray(spec.value)) {
                                values = spec.value;
                            } else if (spec.originalValue && Array.isArray(spec.originalValue)) {
                                values = spec.originalValue;
                            }

                            if (Array.isArray(values)) {
                                specHtmlValue = values.map((tag: any) => {
                                    return `<span class="${tag.slug}">${tag.name}</span>`;
                                }).join('');

                                specCSSValue = values.join(', ');
                            } else {
                                specCSSValue = specHtmlValue = spec.value;
                            }
                        } else {
                            specCSSValue = specHtmlValue = spec.value;
                        }

                        reference = tagTypeField.reference.toLowerCase();
                        indexedHtmlValues[reference] = specHtmlValue;
                        indexedCssValues[reference] = specCSSValue;
                    }
                };

                // process the defaults first.
                specDefaults.forEach(processSpec);
                // any spec values that aren't default will overwrite the reference.
                specValues.forEach(processSpec);
            }

            const indexedDefaultValues = this.getDefaultIndexedValues(tag);

            Object.assign(indexedHtmlValues, indexedDefaultValues);
            Object.assign(indexedCssValues, indexedDefaultValues);
        }

        this.getTemplateViewModel().indexedHtmlValues(indexedHtmlValues);
        this.getTemplateViewModel().indexedCssValues(indexedCssValues);
    }

    private getDefaultIndexedValues(tag) {
        let indexedValues = {};
        // indexedValues['default_id'] = tag.id;
        indexedValues['default_name'] = tag.name;
        if(tag.type) {
            indexedValues['default_tag_type'] = tag.type.name;
            indexedValues['default_dataset'] = tag.type.dataset ? tag.type.dataset.name : '';
        }

        indexedValues['default_color'] = tag.defaults.color;
        indexedValues['default_image_url'] = tag.defaults.image ? tag.defaults.image.url : '';
        indexedValues['default_icon_url'] = tag.defaults.iconImage ? tag.defaults.iconImage.url : '';
        indexedValues['default_seo_description'] = tag.defaults.shortDescription;
        indexedValues['default_review_score'] = tag.defaults.reviewScore;
        indexedValues['default_description'] = tag.defaults.description;

        if(tag.details) {
            if (tag.details.color) {
                indexedValues['default_color'] = tag.details.color;
            }
            if (tag.details.image) {
                indexedValues['default_image_url'] = tag.details.image.url;
            }
            if (tag.details.iconImage) {
                indexedValues['default_icon_url'] = tag.details.iconImage.url;
            }
            if (tag.details.shortDescription) {
                indexedValues['default_seo_description'] = tag.details.shortDescription;
            }
            if (tag.details.reviewScore) {
                indexedValues['default_review_score'] = tag.details.reviewScore;
            }
            if (tag.details.description) {
                indexedValues['default_description'] = tag.details.description;
            }
        }

        return indexedValues;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/vignettePreview_template.ts